// import { FormEvent, useState } from "react";
// import {
//   Alert,
//   Badge,
//   Button,
//   Card,
//   Col,
//   Form,
//   Modal,
//   Row,
//   Spinner,
//   Table,
// } from "react-bootstrap";
// import {
//   BsDisplay,
//   BsPencilSquare,
//   BsPlusCircle,
//   BsSave,
//   BsTrash3,
// } from "react-icons/bs";

// import InventarioService from "../../../Services/Catalogos/InventarioService";
// import { DTOEquipoInventario } from "../../../DTO/Inventario/DTOEquipoInventario";
// import { DTOMonitorInventario } from "../../../DTO/Inventario/DTOMonitorInventario";
// import { DTOEstadoEquipo } from "../../../DTO/Inventario/DTOCatalogosInventario";
// import { DTOGestionarMonitor } from "../../../DTO/Inventario/DTOGestionInventario";

// interface MensajeInventario {
//   encabezado: string;
//   mensaje: string;
//   color?: string;
// }

// interface MonitoresEquipoProps {
//   idEquipo: number;
//   equipo: DTOEquipoInventario;
//   monitores: DTOMonitorInventario[];
//   estadosEquipo: DTOEstadoEquipo[];
//   onRecargar: () => Promise<void>;
//   onMensaje: (mensaje: MensajeInventario) => void;
// }

// type TipoAsignacionMonitor = "EMPLEADO" | "RESPONSABLE" | "SIN_ASIGNAR";

// interface ConfirmacionMonitor {
//   id: number;
//   descripcion: string;
// }

// const crearFormularioMonitor = (): DTOGestionarMonitor => ({
//   accion: "INSERTAR",
//   idEstadoEquipo: null,
//   serviceTagSerial: "",
//   numEmpleadoAsignado: "",
//   nombreResponsable: "",
//   idEquipoRelacionado: null,
//   observaciones: "",
// });

// const obtenerMensajeError = (error: unknown): string => {
//   const errorAxios = error as {
//     response?: { data?: { mensaje?: string } };
//     message?: string;
//   };

//   return (
//     errorAxios.response?.data?.mensaje ??
//     errorAxios.message ??
//     "Ocurrió un error inesperado."
//   );
// };

// const MonitoresEquipo = ({
//   idEquipo,
//   equipo,
//   monitores,
//   estadosEquipo,
//   onRecargar,
//   onMensaje,
// }: MonitoresEquipoProps) => {
//   const [procesando, setProcesando] = useState(false);
//   const [showMonitor, setShowMonitor] = useState(false);
//   const [monitorEditar, setMonitorEditar] =
//     useState<DTOMonitorInventario | null>(null);
//   const [tipoAsignacionMonitor, setTipoAsignacionMonitor] =
//     useState<TipoAsignacionMonitor>("SIN_ASIGNAR");
//   const [monitorForm, setMonitorForm] =
//     useState<DTOGestionarMonitor>(crearFormularioMonitor);
//   const [confirmacion, setConfirmacion] =
//     useState<ConfirmacionMonitor | null>(null);

//   const abrirNuevoMonitor = () => {
//     let tipoAsignacion: TipoAsignacionMonitor = "SIN_ASIGNAR";

//     if (equipo.numEmpleadoAsignado) {
//       tipoAsignacion = "EMPLEADO";
//     } else if (equipo.nombreResponsable) {
//       tipoAsignacion = "RESPONSABLE";
//     }

//     setMonitorEditar(null);
//     setTipoAsignacionMonitor(tipoAsignacion);
//     setMonitorForm({
//       accion: "INSERTAR",
//       idEstadoEquipo:
//         estadosEquipo.find(
//           (estado) => estado.estado.toLowerCase() === "activo"
//         )?.idEstadoEquipo ?? null,
//       serviceTagSerial: "",
//       numEmpleadoAsignado:
//         tipoAsignacion === "EMPLEADO"
//           ? equipo.numEmpleadoAsignado ?? ""
//           : "",
//       nombreResponsable:
//         tipoAsignacion === "RESPONSABLE"
//           ? equipo.nombreResponsable ?? ""
//           : "",
//       idEquipoRelacionado: idEquipo,
//       observaciones: "",
//     });
//     setShowMonitor(true);
//   };

//   const abrirEditarMonitor = (monitor: DTOMonitorInventario) => {
//     let tipoAsignacion: TipoAsignacionMonitor = "SIN_ASIGNAR";

//     if (monitor.numEmpleadoAsignado) {
//       tipoAsignacion = "EMPLEADO";
//     } else if (monitor.nombreResponsable) {
//       tipoAsignacion = "RESPONSABLE";
//     }

//     setMonitorEditar(monitor);
//     setTipoAsignacionMonitor(tipoAsignacion);
//     setMonitorForm({
//       accion: "ACTUALIZAR",
//       idMonitor: monitor.idMonitor,
//       idEstadoEquipo: monitor.idEstadoEquipo,
//       serviceTagSerial: monitor.serviceTagSerial ?? "",
//       numEmpleadoAsignado: monitor.numEmpleadoAsignado ?? "",
//       nombreResponsable: monitor.nombreResponsable ?? "",
//       idEquipoRelacionado: monitor.idEquipoRelacionado ?? idEquipo,
//       observaciones: monitor.observaciones ?? "",
//     });
//     setShowMonitor(true);
//   };

//   const manejarTipoAsignacionMonitor = (tipo: TipoAsignacionMonitor) => {
//     setTipoAsignacionMonitor(tipo);

//     if (tipo === "EMPLEADO") {
//       setMonitorForm((prev) => ({ ...prev, nombreResponsable: "" }));
//       return;
//     }

//     if (tipo === "RESPONSABLE") {
//       setMonitorForm((prev) => ({ ...prev, numEmpleadoAsignado: "" }));
//       return;
//     }

//     setMonitorForm((prev) => ({
//       ...prev,
//       numEmpleadoAsignado: "",
//       nombreResponsable: "",
//     }));
//   };

//   const guardarMonitor = async (event: FormEvent<HTMLFormElement>) => {
//     event.preventDefault();

//     if (!monitorForm.idEstadoEquipo) return;

//     setProcesando(true);

//     try {
//       const respuesta = await InventarioService.gestionarMonitor({
//         ...monitorForm,
//         idEquipoRelacionado: idEquipo,
//         serviceTagSerial: monitorForm.serviceTagSerial?.trim() || null,
//         numEmpleadoAsignado:
//           tipoAsignacionMonitor === "EMPLEADO"
//             ? monitorForm.numEmpleadoAsignado?.trim() || null
//             : null,
//         nombreResponsable:
//           tipoAsignacionMonitor === "RESPONSABLE"
//             ? monitorForm.nombreResponsable?.trim() || null
//             : null,
//         observaciones: monitorForm.observaciones?.trim() || null,
//       });

//       setShowMonitor(false);
//       setMonitorEditar(null);
//       onMensaje({
//         encabezado: "Éxito",
//         mensaje: respuesta.data.mensaje,
//         color: "success",
//       });
//       await onRecargar();
//     } catch (errorPeticion) {
//       onMensaje({
//         encabezado: "Error",
//         mensaje: obtenerMensajeError(errorPeticion),
//         color: "danger",
//       });
//     } finally {
//       setProcesando(false);
//     }
//   };

//   const eliminarMonitor = async () => {
//     if (!confirmacion) return;

//     setProcesando(true);

//     try {
//       const respuesta = await InventarioService.gestionarMonitor({
//         accion: "ELIMINAR",
//         idMonitor: confirmacion.id,
//       });

//       onMensaje({
//         encabezado: "Éxito",
//         mensaje: respuesta.data.mensaje,
//         color: "success",
//       });
//       setConfirmacion(null);
//       await onRecargar();
//     } catch (errorPeticion) {
//       onMensaje({
//         encabezado: "Error",
//         mensaje: obtenerMensajeError(errorPeticion),
//         color: "danger",
//       });
//     } finally {
//       setProcesando(false);
//     }
//   };

//   return (
//     <>
//       <Card className="border-0 shadow-sm mb-3">
//         <Card.Header className="bg-white border-0 pt-3 d-flex align-items-center justify-content-between">
//           <span className="fw-bold">
//             <BsDisplay className="me-2 text-primary" />
//             Monitores
//           </span>

//           <Button
//             size="sm"
//             variant="outline-primary"
//             onClick={abrirNuevoMonitor}
//           >
//             <BsPlusCircle className="me-1" />
//             Agregar
//           </Button>
//         </Card.Header>

//         <Card.Body className="p-0">
//           <Table responsive hover className="mb-0">
//             <thead className="table-light">
//               <tr>
//                 <th className="small">Serial</th>
//                 <th className="small">Estado</th>
//                 <th className="small">Asignado a </th>
//                 <th className="small">Observaciones</th>
//                 <th className="small">Acciones</th>
//               </tr>
//             </thead>

//             <tbody>
//               {monitores.map((monitor) => (
//                 <tr key={monitor.idMonitor}>
//                   <td className="font-monospace small">
//                     {monitor.serviceTagSerial ?? "—"}
//                   </td>
//                   <td>
//                     <Badge bg="success">
//                       {monitor.estadoMonitor ?? "Activo"}
//                     </Badge>
//                   </td>
//                   <td className="small">
//                     {monitor.numEmpleadoAsignado ? (
//                       <div>
//                         <div className="fw-semibold">
//                           {monitor.nombreEmpleado ?? monitor.numEmpleadoAsignado}
//                         </div>
//                         <div className="text-muted">
//                           Empleado #{monitor.numEmpleadoAsignado}
//                         </div>
//                       </div>
//                     ) : monitor.nombreResponsable ? (
//                       <div>
//                         <div className="fw-semibold">
//                           {monitor.nombreResponsable}
//                         </div>
//                         <div className="text-muted">Responsable externo</div>
//                       </div>
//                     ) : (
//                       <div>
//                         <div className="fw-semibold text-muted">Sin asignar</div>
//                         <div className="text-muted">Disponible</div>
//                       </div>
//                     )}
//                   </td>
//                   <td className="small">{monitor.observaciones ?? "—"}</td>
//                   <td>
//                     <div className="d-flex gap-1">
//                       <Button
//                         size="sm"
//                         variant="outline-secondary"
//                         onClick={() => abrirEditarMonitor(monitor)}
//                       >
//                         <BsPencilSquare />
//                       </Button>
//                       <Button
//                         size="sm"
//                         variant="outline-danger"
//                         onClick={() =>
//                           setConfirmacion({
//                             id: monitor.idMonitor,
//                             descripcion:
//                               monitor.serviceTagSerial ??
//                               `Monitor ${monitor.idMonitor}`,
//                           })
//                         }
//                       >
//                         <BsTrash3 />
//                       </Button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}

//               {monitores.length === 0 && (
//                 <tr>
//                   <td colSpan={5} className="text-center py-4 text-muted">
//                     Sin monitores relacionados.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </Card.Body>
//       </Card>

//       <Modal
//         show={showMonitor}
//         onHide={() => {
//           if (!procesando) {
//             setShowMonitor(false);
//             setMonitorEditar(null);
//           }
//         }}
//         centered
//         backdrop="static"
//       >
//         <Form onSubmit={guardarMonitor}>
//           <Modal.Header closeButton>
//             <Modal.Title className="d-flex align-items-center gap-3 fs-5">
//               <div
//                 className="d-flex align-items-center justify-content-center rounded-3"
//                 style={{
//                   width: 42,
//                   height: 42,
//                   color: "#0d6efd",
//                   backgroundColor: "#e8f1ff",
//                 }}
//               >
//                 <BsDisplay size={21} />
//               </div>
//               <div>
//                 <div className="fw-bold">
//                   {monitorEditar ? "Editar monitor" : "Registrar monitor"}
//                 </div>
//                 <div className="text-muted fw-normal" style={{ fontSize: 12 }}>
//                   Monitor relacionado con el equipo
//                 </div>
//               </div>
//             </Modal.Title>
//           </Modal.Header>

//           <Modal.Body style={{ backgroundColor: "#f8f9fa" }}>
//             <Row className="g-3">
//               <Col xs={12}>
//                 <Form.Group>
//                   <Form.Label className="small fw-semibold">
//                     Estado <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Select
//                     value={monitorForm.idEstadoEquipo ?? ""}
//                     onChange={(event) =>
//                       setMonitorForm({
//                         ...monitorForm,
//                         idEstadoEquipo: Number(event.target.value) || null,
//                       })
//                     }
//                     required
//                   >
//                     <option value="">Seleccione un estado</option>
//                     {estadosEquipo.map((estado) => (
//                       <option
//                         key={estado.idEstadoEquipo}
//                         value={estado.idEstadoEquipo}
//                       >
//                         {estado.estado}
//                       </option>
//                     ))}
//                   </Form.Select>
//                 </Form.Group>
//               </Col>

//               <Col xs={12}>
//                 <Form.Group>
//                   <Form.Label className="small fw-semibold">
//                     Service Tag / Serial
//                   </Form.Label>
//                   <Form.Control
//                     value={monitorForm.serviceTagSerial ?? ""}
//                     onChange={(event) =>
//                       setMonitorForm({
//                         ...monitorForm,
//                         serviceTagSerial: event.target.value,
//                       })
//                     }
//                     placeholder="Serial del monitor"
//                     maxLength={100}
//                   />
//                 </Form.Group>
//               </Col>

//               <Col xs={12}>
//                 <Form.Group>
//                   <Form.Label className="small fw-semibold">
//                     Tipo de asignación
//                   </Form.Label>
//                   <div className="d-flex flex-wrap gap-3">
//                     <Form.Check
//                       type="radio"
//                       id="monitor-empleado"
//                       name="tipoAsignacionMonitor"
//                       label="Empleado"
//                       checked={tipoAsignacionMonitor === "EMPLEADO"}
//                       onChange={() => manejarTipoAsignacionMonitor("EMPLEADO")}
//                     />
//                     <Form.Check
//                       type="radio"
//                       id="monitor-responsable"
//                       name="tipoAsignacionMonitor"
//                       label="Responsable externo"
//                       checked={tipoAsignacionMonitor === "RESPONSABLE"}
//                       onChange={() =>
//                         manejarTipoAsignacionMonitor("RESPONSABLE")
//                       }
//                     />
//                     <Form.Check
//                       type="radio"
//                       id="monitor-sin-asignar"
//                       name="tipoAsignacionMonitor"
//                       label="Sin asignar"
//                       checked={tipoAsignacionMonitor === "SIN_ASIGNAR"}
//                       onChange={() =>
//                         manejarTipoAsignacionMonitor("SIN_ASIGNAR")
//                       }
//                     />
//                   </div>
//                 </Form.Group>
//               </Col>

//               {tipoAsignacionMonitor === "EMPLEADO" && (
//                 <Col xs={12}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">
//                       Número de empleado
//                     </Form.Label>
//                     <Form.Control
//                       value={monitorForm.numEmpleadoAsignado ?? ""}
//                       onChange={(event) =>
//                         setMonitorForm((prev) => ({
//                           ...prev,
//                           numEmpleadoAsignado: event.target.value,
//                         }))
//                       }
//                       placeholder="Ej. 010164"
//                       maxLength={20}
//                     />
//                   </Form.Group>
//                 </Col>
//               )}

//               {tipoAsignacionMonitor === "RESPONSABLE" && (
//                 <Col xs={12}>
//                   <Form.Group>
//                     <Form.Label className="small fw-semibold">
//                       Nombre del responsable
//                     </Form.Label>
//                     <Form.Control
//                       value={monitorForm.nombreResponsable ?? ""}
//                       onChange={(event) =>
//                         setMonitorForm((prev) => ({
//                           ...prev,
//                           nombreResponsable: event.target.value,
//                         }))
//                       }
//                       placeholder="Ej. Patricia Guajardo"
//                       maxLength={150}
//                     />
//                   </Form.Group>
//                 </Col>
//               )}

//               {tipoAsignacionMonitor === "SIN_ASIGNAR" && (
//                 <Col xs={12}>
//                   <Alert variant="secondary" className="mb-0">
//                     El monitor quedará sin empleado ni responsable asignado.
//                   </Alert>
//                 </Col>
//               )}

//               <Col xs={12}>
//                 <Form.Group>
//                   <Form.Label className="small fw-semibold">
//                     Observaciones
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     value={monitorForm.observaciones ?? ""}
//                     onChange={(event) =>
//                       setMonitorForm({
//                         ...monitorForm,
//                         observaciones: event.target.value,
//                       })
//                     }
//                     maxLength={500}
//                   />
//                 </Form.Group>
//               </Col>
//             </Row>
//           </Modal.Body>

//           <Modal.Footer>
//             <Button
//               variant="light"
//               disabled={procesando}
//               onClick={() => {
//                 setShowMonitor(false);
//                 setMonitorEditar(null);
//               }}
//             >
//               Cancelar
//             </Button>
//             <Button type="submit" disabled={procesando}>
//               {procesando ? (
//                 <>
//                   <Spinner size="sm" animation="border" className="me-2" />
//                   Guardando...
//                 </>
//               ) : (
//                 <>
//                   <BsSave className="me-2" />
//                   Guardar monitor
//                 </>
//               )}
//             </Button>
//           </Modal.Footer>
//         </Form>
//       </Modal>

//       <Modal
//         show={confirmacion !== null}
//         onHide={() => {
//           if (!procesando) setConfirmacion(null);
//         }}
//         centered
//       >
//         <Modal.Header
//           closeButton
//           className="bg-danger text-white"
//           closeVariant="white"
//         >
//           <Modal.Title className="fs-6 fw-bold">Confirmar baja</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="bg-light">
//           <div className="text-center py-3">
//             <BsTrash3 size={36} className="text-danger mb-3" />
//             <h5 className="fw-bold">¿Confirmas esta acción?</h5>
//             <p className="mb-1 text-muted">Se dará de baja:</p>
//             <p className="fw-bold">{confirmacion?.descripcion}</p>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="light"
//             disabled={procesando}
//             onClick={() => setConfirmacion(null)}
//           >
//             Cancelar
//           </Button>
//           <Button
//             variant="danger"
//             disabled={procesando}
//             onClick={() => void eliminarMonitor()}
//           >
//             {procesando ? (
//               <>
//                 <Spinner size="sm" animation="border" className="me-2" />
//                 Procesando...
//               </>
//             ) : (
//               <>
//                 <BsTrash3 className="me-2" />
//                 Sí, dar de baja
//               </>
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default MonitoresEquipo;

import { useState } from "react";

import {
  Alert,
  Badge,
  Button,
  Card,
  Form,
  Modal,
  Spinner,
  Table,
} from "react-bootstrap";

import {
  BsArrowCounterclockwise,
  BsDisplay,
  BsPlusCircle,
} from "react-icons/bs";

import InventarioService from "../../../Services/Catalogos/InventarioService";

import { DTOEquipoInventario } from "../../../DTO/Inventario/DTOEquipoInventario";
import { DTOMonitorInventario } from "../../../DTO/Inventario/DTOMonitorInventario";
import { DTOEstadoEquipo } from "../../../DTO/Inventario/DTOCatalogosInventario";

interface MensajeInventario {
  encabezado: string;
  mensaje: string;
  color?: string;
}

interface MonitoresEquipoProps {
  idEquipo: number;
  equipo: DTOEquipoInventario;
  monitores: DTOMonitorInventario[];
  estadosEquipo: DTOEstadoEquipo[];
  onRecargar: () => Promise<void>;
  onMensaje: (mensaje: MensajeInventario) => void;
}

const obtenerMensajeError = (error: unknown): string => {
  const errorAxios = error as {
    response?: {
      data?: {
        mensaje?: string;
      };
    };
    message?: string;
  };

  return (
    errorAxios.response?.data?.mensaje ??
    errorAxios.message ??
    "Ocurrió un error inesperado."
  );
};

const obtenerColorEstado = (
  estado?: string | null
): string => {
  const estadoNormalizado =
    estado?.trim().toLowerCase() ?? "";

  if (estadoNormalizado === "activo") return "success";
  if (estadoNormalizado.includes("repar")) return "warning";

  return "secondary";
};

const MonitoresEquipo = ({
  idEquipo,
  equipo,
  monitores,
  onRecargar,
  onMensaje,
}: MonitoresEquipoProps) => {
  const [showAsignar, setShowAsignar] =
    useState(false);

  const [monitoresDisponibles, setMonitoresDisponibles] =
    useState<DTOMonitorInventario[]>([]);

  const [idMonitorSeleccionado, setIdMonitorSeleccionado] =
    useState<number | null>(null);

  const [monitorDesasignar, setMonitorDesasignar] =
    useState<DTOMonitorInventario | null>(null);

  const [cargandoDisponibles, setCargandoDisponibles] =
    useState(false);

  const [procesando, setProcesando] =
    useState(false);

  const abrirAsignacion = async () => {
    setShowAsignar(true);
    setIdMonitorSeleccionado(null);
    setMonitoresDisponibles([]);
    setCargandoDisponibles(true);

    try {
      const respuesta =
        await InventarioService.obtenerMonitores(
          "DISPONIBLES"
        );

      setMonitoresDisponibles(respuesta.data);
    } catch (errorPeticion) {
      setShowAsignar(false);

      onMensaje({
        encabezado: "Error",
        mensaje: obtenerMensajeError(errorPeticion),
        color: "danger",
      });
    } finally {
      setCargandoDisponibles(false);
    }
  };

  const cerrarAsignacion = () => {
    if (procesando) return;

    setShowAsignar(false);
    setIdMonitorSeleccionado(null);
    setMonitoresDisponibles([]);
  };

  const asignarMonitor = async () => {
    if (!idMonitorSeleccionado) {
      onMensaje({
        encabezado: "Aviso",
        mensaje: "Selecciona un monitor disponible.",
        color: "warning",
      });
      return;
    }

    setProcesando(true);

    try {
      const respuesta =
        await InventarioService.gestionarMonitor({
          accion: "ASIGNAR",
          idMonitor: idMonitorSeleccionado,
          idEquipoRelacionado: idEquipo,
        });

      setShowAsignar(false);
      setIdMonitorSeleccionado(null);
      setMonitoresDisponibles([]);

      onMensaje({
        encabezado: "Éxito",
        mensaje: respuesta.data.mensaje,
        color: "success",
      });

      await onRecargar();
    } catch (errorPeticion) {
      onMensaje({
        encabezado: "Error",
        mensaje: obtenerMensajeError(errorPeticion),
        color: "danger",
      });
    } finally {
      setProcesando(false);
    }
  };

  const desasignarMonitor = async () => {
    if (!monitorDesasignar) return;

    setProcesando(true);

    try {
      const respuesta =
        await InventarioService.gestionarMonitor({
          accion: "DESASIGNAR",
          idMonitor: monitorDesasignar.idMonitor,
        });

      setMonitorDesasignar(null);

      onMensaje({
        encabezado: "Éxito",
        mensaje: respuesta.data.mensaje,
        color: "success",
      });

      await onRecargar();
    } catch (errorPeticion) {
      onMensaje({
        encabezado: "Error",
        mensaje: obtenerMensajeError(errorPeticion),
        color: "danger",
      });
    } finally {
      setProcesando(false);
    }
  };

  return (
    <>
      <Card className="border-0 shadow-sm mb-3">
        <Card.Header className="bg-white border-0 pt-3 d-flex flex-wrap align-items-center justify-content-between gap-2">
          <div>
            <div className="fw-bold">
              <BsDisplay className="me-2 text-primary" />
              Monitores asignados
            </div>

            <div
              className="text-muted mt-1"
              style={{ fontSize: 12 }}
            >
              {equipo.nombreEquipo}
            </div>
          </div>

          <Button
            size="sm"
            variant="outline-primary"
            onClick={() => void abrirAsignacion()}
          >
            <BsPlusCircle className="me-1" />
            Asignar monitor existente
          </Button>
        </Card.Header>

        <Card.Body className="p-0">
          <Table responsive hover className="mb-0">
            <thead className="table-light">
              <tr>
                <th className="small">Serial</th>
                <th className="small">Estado</th>
                <th className="small">Asignado a</th>
                <th className="small">Observaciones</th>
                <th className="small text-center">
                  Acción
                </th>
              </tr>
            </thead>

            <tbody>
              {monitores.map((monitor) => (
                <tr key={monitor.idMonitor}>
                  <td className="font-monospace small">
                    {monitor.serviceTagSerial ?? "—"}
                  </td>

                  <td>
                    <Badge
                      bg={obtenerColorEstado(
                        monitor.estadoMonitor
                      )}
                    >
                      {monitor.estadoMonitor ?? "—"}
                    </Badge>
                  </td>

                  <td className="small">
                    {monitor.nombreEmpleado ? (
                      <>
                        <div className="fw-semibold">
                          {monitor.nombreEmpleado}
                        </div>

                        <div className="text-muted">
                          Empleado #
                          {monitor.numEmpleadoAsignado}
                        </div>
                      </>
                    ) : monitor.nombreResponsable ? (
                      <>
                        <div className="fw-semibold">
                          {monitor.nombreResponsable}
                        </div>

                        <div className="text-muted">
                          Responsable
                        </div>
                      </>
                    ) : (
                      <span className="text-muted">
                        Sin responsable
                      </span>
                    )}
                  </td>

                  <td className="small">
                    {monitor.observaciones ?? "—"}
                  </td>

                  <td className="text-center">
                    <Button
                      size="sm"
                      variant="outline-warning"
                      title="Devolver monitor al stock"
                      onClick={() =>
                        setMonitorDesasignar(monitor)
                      }
                    >
                      <BsArrowCounterclockwise className="me-1" />
                      Devolver
                    </Button>
                  </td>
                </tr>
              ))}

              {monitores.length === 0 && (
                <tr>
                  <td
                    colSpan={5}
                    className="text-center py-4 text-muted"
                  >
                    Este equipo no tiene monitores asignados.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* Seleccionar monitor disponible */}
      <Modal
        show={showAsignar}
        onHide={cerrarAsignacion}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-5">
            <BsDisplay className="me-2 text-primary" />
            Asignar monitor existente
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{ backgroundColor: "#f8fafc" }}
        >
          <Alert variant="info">
            Selecciona un monitor disponible para asignarlo a
            <strong> {equipo.nombreEquipo}</strong>.
          </Alert>

          {cargandoDisponibles ? (
            <div className="text-center py-5">
              <Spinner
                animation="border"
                variant="primary"
              />

              <div className="text-muted mt-2">
                Consultando monitores disponibles...
              </div>
            </div>
          ) : monitoresDisponibles.length === 0 ? (
            <Alert variant="warning" className="mb-0">
              No existen monitores disponibles en stock.
              Registra uno desde la vista general de
              monitores.
            </Alert>
          ) : (
            <Table
              responsive
              hover
              bordered
              className="bg-white mb-0"
            >
              <thead className="table-light">
                <tr>
                  <th style={{ width: 55 }} />
                  <th className="small">Serial</th>
                  <th className="small">Estado</th>
                  <th className="small">
                    Observaciones
                  </th>
                </tr>
              </thead>

              <tbody>
                {monitoresDisponibles.map((monitor) => (
                  <tr
                    key={monitor.idMonitor}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setIdMonitorSeleccionado(
                        monitor.idMonitor
                      )
                    }
                  >
                    <td className="text-center">
                      <Form.Check
                        type="radio"
                        name="monitorDisponible"
                        checked={
                          idMonitorSeleccionado ===
                          monitor.idMonitor
                        }
                        onChange={() =>
                          setIdMonitorSeleccionado(
                            monitor.idMonitor
                          )
                        }
                        aria-label={`Seleccionar monitor ${
                          monitor.serviceTagSerial ??
                          monitor.idMonitor
                        }`}
                      />
                    </td>

                    <td className="font-monospace small">
                      {monitor.serviceTagSerial ?? "—"}
                    </td>

                    <td>
                      <Badge
                        bg={obtenerColorEstado(
                          monitor.estadoMonitor
                        )}
                      >
                        {monitor.estadoMonitor ?? "—"}
                      </Badge>
                    </td>

                    <td className="small">
                      {monitor.observaciones ?? "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            disabled={procesando}
            onClick={cerrarAsignacion}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            disabled={
              procesando ||
              cargandoDisponibles ||
              !idMonitorSeleccionado
            }
            onClick={() => void asignarMonitor()}
          >
            {procesando ? (
              <>
                <Spinner
                  size="sm"
                  animation="border"
                  className="me-2"
                />
                Asignando...
              </>
            ) : (
              <>
                <BsPlusCircle className="me-2" />
                Asignar monitor
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirmar devolución al stock */}
      <Modal
        show={monitorDesasignar !== null}
        onHide={() => {
          if (!procesando) {
            setMonitorDesasignar(null);
          }
        }}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-6 fw-bold">
            Devolver monitor al stock
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            ¿Deseas quitar este monitor del equipo
            <strong> {equipo.nombreEquipo}</strong>?
          </p>

          <div className="p-3 bg-light rounded">
            <div className="fw-semibold">
              {monitorDesasignar?.serviceTagSerial ??
                `Monitor ${monitorDesasignar?.idMonitor}`}
            </div>

            <div className="text-muted small mt-1">
              El monitor no se eliminará. Volverá a aparecer
              como disponible en el stock.
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            disabled={procesando}
            onClick={() =>
              setMonitorDesasignar(null)
            }
          >
            Cancelar
          </Button>

          <Button
            variant="warning"
            disabled={procesando}
            onClick={() =>
              void desasignarMonitor()
            }
          >
            {procesando ? (
              <>
                <Spinner
                  size="sm"
                  animation="border"
                  className="me-2"
                />
                Procesando...
              </>
            ) : (
              <>
                <BsArrowCounterclockwise className="me-2" />
                Sí, devolver al stock
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MonitoresEquipo;